<div #wrapper [ngClass]="!windowScroll ? 'mh-100 overflow-auto' : ''">
  <ng-content></ng-content>
</div>
